import { ListCollection, Portal, Select } from '@chakra-ui/react';

type SelectItem = { value: string; label: string };

interface Props {
  label?: string;
  placeholder: string;
  collection: ListCollection<SelectItem>;
  value?: string[];
  onValueChange?: (details: { value: string[] }) => void;
}

const SelectField = ({ label, placeholder, collection, value, onValueChange }: Props) => (
  <Select.Root
    collection={collection}
    size="sm"
    value={value}
    onValueChange={onValueChange}
  >
    <Select.HiddenSelect />
    {label != null && (
      <Select.Label fontSize="xs" color="text.secondary" mb={0}>
        {label}
      </Select.Label>
    )}
    <Select.Control>
      <Select.Trigger borderColor="border.light" borderRadius="md">
        <Select.ValueText placeholder={placeholder} fontSize="sm" />
      </Select.Trigger>
      <Select.IndicatorGroup>
        <Select.Indicator />
      </Select.IndicatorGroup>
    </Select.Control>
    <Portal>
      <Select.Positioner>
        <Select.Content bg="surface.background">
          {collection.items.map((item) => (
            <Select.Item item={item} key={item.value}>
              {item.label}
              <Select.ItemIndicator />
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Portal>
  </Select.Root>
);

export default SelectField;
